import { useSelector } from "@tanstack/react-store"
import { createStore } from "@tanstack/store"
import { registerSessionCleanup } from "@/shared/lib/auth"

interface DailyQuestionAnswerState {
	open: boolean
	question: string
}

const dailyQuestionAnswerStore = createStore<DailyQuestionAnswerState>({
	open: false,
	question: "",
})

export function showDailyQuestionAnswer(question: string): void {
	dailyQuestionAnswerStore.setState((state) => ({
		...state,
		open: true,
		question,
	}))
}

export function hideDailyQuestionAnswer(): void {
	dailyQuestionAnswerStore.setState(() => ({ open: false, question: "" }))
}

export function useDailyQuestionAnswer(): DailyQuestionAnswerState {
	return useSelector(dailyQuestionAnswerStore)
}

registerSessionCleanup(hideDailyQuestionAnswer)
